export default __webpack_public_path__ + "static/media/export-grey.9d5e8a6a.svg";